import _ from 'lodash';
import moment from 'moment-timezone'
import Constants from './Constants';

//Constants definition
var getKeyorValue = (Obj, param) => {
    return _.get(Obj, param) || _.get(_.invert(Obj), param)
}

var getKeyorValueToSports = (Obj, param, isConvertDash) => {
  if (!isConvertDash) {
    return _.get(Obj, param) || _.get(_.invert(Obj), param);
  } else {
    let sportName = _.get(Obj, param);
    // If the param is sport id, the sport name will be returned.
    if (sportName) {
      return param === Constants.ESPORT_ID
        ? _.lowerCase(sportName).replaceAll(' ', '')
        : _.lowerCase(sportName).replaceAll(' ', '-');
    } else if (typeof param === 'string') {
      // If the param is sport name, we will replace the dash character to a space.
      sportName = param && param.replaceAll('-', ' ');
      // Find sport id from SPORT Object by sport name
      return _.find(_.invert(Obj), (id, name) => _.isEqual(_.lowerCase(name), _.lowerCase(sportName)));
    }
    return sportName;
  }
}

export const GROUP_SPORT_PERIODS = {
    sportId: 0,
    groupPeriod: 1 
}

export const PERIODS_DESC = {
    periodNumber: 0,
    description: 1,
    shortDescription: 2
}

export const TIME_REFRESH_BETSLIP = 10

export const ODDS_SEPARATE = '|'

export const DEFAULT_DATES = [
    {
      text: 'All dates',
      value: '',
      priority: 0
    },
    {
      text: 'Onwards',
      value: Constants.ONWARDS,
      priority: 999
    }
]

export const E_SPORT_ID = 12;

export const HOME_AWAY_LABEL = {
    0: {
        description: ["Home", "Away"],
        shortDescription: ["H", "A"],
    },
    33: {
        description: ["Player 1", "Player 2"],
        shortDescription: ["P1", "P2"]
    }
}

export const RUNNING_STATE_EXTRA_TIME = ["1H ET", "2H ET", "HT ET", "END ET", "HTEX", "EEX"];

export const EXTRA_TIME_PERIOD = 3;

export const OddsConstant = { 
    mlType: [
      {
        id: 0,
        oddData: 1,
        selectionType: 0, // Home
      },
      {
        id: 1,
        oddData: 0,
        selectionType: 1, // Away
      }
    ],
    hdpType: [
      {
        id: 0,
        oddData: 3,
        selectionType: 0, // Home
        ou: 1
      },
      {
        id: 1,
        oddData: 4,
        selectionType: 1, // Away
        ou: 0
      }
    ],
    ouType: [
      {
        id: 0,
        oddData: 2,
        selectionType: 3, // Over
        ou: 1
      },
      {
        id: 1,
        oddData: 3,
        selectionType: 4, // Under
        ou: 0
      }
    ]
  };

export const CHANEL = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export const PRESTIGE_KEYS = {
  HEADER: 'header',
  CONTENT: 'content',
  TRANSLATIONS: 'translations',
  ADVERTISEMENTS: 'advertisements',
  BENEFITS: 'benefits',
  OTHERS: 'others',
  BUTTON: 'button',
  TEXT_EXPAND: 'text_expand',
};

export const PAGE_TITLE = {
  messagesPageContainer: {
    title: 'Header_._Messages',
    titleIcon: 'fa fa-envelope',
  },
  profilePageContainer: {
    title: 'Profile',
    titleIcon: 'fa fa-info-circle',
  },
  balancePageContainer: {
    title: 'Balance',
    titleIcon: 'fa fa-money',
  },
  myBetsPageContainer: {
    title: 'My Bets',
    titleIcon: 'fa fa-list-ol',
  },
  statementPageContainer: {
    title: 'Statements',
    titleIcon: 'fa fa-calendar',
  },
  settingsPageContainer: {
    title: 'Settings',
    titleIcon: 'fa fa-cog',
  },
  resultsPageContainer: {
    title: 'Header_._Results',
    titleIcon: 'fa fa-trophy',
  },
  promotionsPageContainer: {
    title: 'Promotions',
    titleIcon: 'propmotion-topbar-fa fa fa-gift',
    disabledRefresh: true,
    className: 'propmotion-topbar'
  },
  announcementsPageContainer: {
    title: 'Announcements',
    titleIcon: 'fa fa-bullhorn',
  },
  termsConditionsPageContainer: {
    title: 'Terms & Conditions',
    titleIcon: 'fa fa-envelope',
  },
  WithdrawalContainer: {
    title: 'Withdrawal',
    titleIcon: 'fa fa-envelope withdrawal-icon',
    disabledRefresh: true,
  },
  SelfExclusionContainer: {
    title: 'Self Exclusion',
    titleIcon: 'fa fa-envelope self-exclusion-icon',
    disabledRefresh: true,
  }
}

export const IGNORE_SEAMLESS_MENUS = [
  "Balance"
]

export const REQUIRED_LOGIN_PAGE = [
  "profilePageContainer",
  "messagesPageContainer",
  "balancePageContainer",
  "myBetsPageContainer",
  "statementPageContainer",
  "settingsPageContainer",
  "resultsPageContainer",
  "announcementsPageContainer",
  "prestigeClubPageContainer",
  "WithdrawalContainer",
  "SelfExclusionContainer"
];

export const SUPPORT_RUNNING_TICKER_PAGES = {
  euroView: ['homePageContainer', 'liveGamesContainer', 'leaguesPageContainer', 'oddsPageContainer']
}

export const E_SPORTS_ROUTES = {
  matchupPage: [
    '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/asian/:view?/sports/:sportName?/:code?/:market?/:betTypeGroup?/:matchupId?/:period?', 
    '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/asian/:view?/esports/:code?/:market?/:betTypeGroup?/:matchupId?/:period?', 
    '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/asian/:view?/inplay/:sportName?/:code?/:market?/:betTypeGroup?/:matchupId?/:period?', 
  ],
}

export const ANNOUNCEMENT_FEATURE = [
  "Announcements"
];

export const RESULTS_FEATURE = [
    "Results"
];

export const WITHDRAWAL_FEATURE = [
    "Withdrawal"
];

export const PRESTIGE_CLUB_FEATURE = [
    "Prestige Club"
];

export const ANNOUNCEMENT_PAGES = [
  "announcementsPageContainer"
];

export const PRESTIGE_CLUB_PAGES = [
  "prestigeClubPageContainer"
];

export const ANNOUNCEMENT_TYPE = {
  ann: 'Site Announcements',
  matchAnn: 'Match Announcements'
}

export const FILTER_BAR = {
    MARKET: 'MARKET',
    GAME: 'GAME',
    LEAGUE: 'LEAGUE',
    TEASER: 'TEASER',
    PARLAY: 'PARLAY',
    OUTRIGHT_TYPE: 'OUTRIGHT_TYPE',
    OPTIONS: 'OPTIONS',
    SPORTS: 'SPORTS',
    SEARCH: 'SEARCH'
}

export const OPTION_FIELDS = {
    MARKET: 'market',
    ESPORTS: 'eSports',
    LEAGUES: 'leagueIds',
    TEASER: 'teaser',
    PARLAY: 'parlay',
    OUTRIGHT: 'outright',
    SPORTS: "sports"
}

export const CorrectScoreTypes = {
    WIN: 'WIN',
    DRAW: 'DRAW',
    LOSE: 'LOSE',
}

export const SportEvents = {
    id: 0,
    name: 1,
    leagues: 2,
    version: 3,
    group: 4,
    summary: 5,
    betTypeSummary: 6,
    hasDrawPrice: 7
}

export const SportVO = {
    id: 0,
    piority: 1,
    hasLines: 2,
    name: 3,
    hasParlay: 4
}

export const LeagueVO = {
    id: 0,
    piority: 1,
    name: 2
}

export const SportResults = {
    sportId: 0,
    sportName: 1,
    leagues: 2,
    sportGroup: 3
}

export const LeagueResults = {
    leagueName: 0,
    events: 1
}

export const EventResults = {
    homeTeam: 0,
    awayTeam: 1,
    eventDate: 2,
    homeTeamWin: 3,
    awayTeamWin: 4,
    period: 5,
    results: 6
}

export const EventMapping = {
  events: 0,
  leagues: 2,
}

export const OutRightOdds = {
    leagueId: 'li',
    leagueName: 'ln',
    specialEvents: 'se',
    specialId: 'si',
    parentEventName: 'levn',
    parentEventId: 'parentId',
    eventDate: 'lt',
    category: 'cg',
    isLive: 'ile'
}

export const OutRightResponse = {
    updates: 'u',
    leagues: 'a',
    fixtureSince: 'f',
    sportIdsSinceMap: 'o'
}

export const EuroViewOdds = {
    liveBets: 'lb',
    highLightEvents: 'hle',
    featureEvents: 'fe',
    populars: 'p',
    updateVersions: 'uv',
    liveUpdateVersion: 'luv',
    updates: 'u',
    liveEvents: 'l',
    normalEvents: 'n',
    event: 'e',
    totalLeagues: 'lg',
    totalParaly: 'pt',
    parlaySports: 'ps',
    dates: 'd'
}

export const SpecialEvent = {
    status: 'st',
    specialId: 'si',
    minBet: 'm',
    maxBet: 'x',
    maxBetCurrency: 'xc',
    specialName: 'n',
    date: 'd',
    eventName: 'e',
    parentEventId: 'ei',
    contestantLines: 'l',
    category: 'cg',
    unit: 'un',
    periodNumber: "pe",
    betType: 'bt',
    originalUnit: 'oun'
}

export const ContestantLine = {
    contestantLineId: 'i',
    lineId: 'l',
    name: 'n',
    price: 'p',
    handicap: 'h',
    priceChange: 'c',
    rotationNumber: 'rn'
}

export const LeagueEvents = {
    id: 0,
    name: 1,
    events: 2,
    summary: 3,
    originalName: 4
}

export const FullEvent = {
    sportId: 0,
    leaugeId: 1,
    sportGroup: 2,
    event: 3,
    version: 4
}

export const EventDetail = {
    id: 0,
    homeName: 1,
    awayName: 2,
    lines: 3,
    time: 4,
    running: 5,
    live: 6,
    moreBets: 7,
    periods: 8,
    scores: 9,
    redCards: 10,
    teamType: 11,
    baseBall: 12,
    homePitcher: 13,
    awayPitcher: 14,
    runningTime: 15,
    runningPeriod: 16,
    eventStatus: 17,
    liveCenter: 18,
    liveTV: 19,
    liveCenterId: 20,
    totalMarkets: 21,
    parlayRestriction: 22, //Value indicate parlay support: 0: not support, 1: support, 2: support 1 leg parlay.
    totalOutrightOdds: 23,
    originalHomeName: 24,
    originalAwayName: 25,
    rotationNumber: 26,
    unitResults: 27,
    parentEventId:28,
    isUnitResults: 29,
    isExistGradingUnit: 29, // new Tennis
    isGameInTeamName: 30  // new Tennis
}

export const PeriodDetail = {
  tt: 0,
  special: 1,
  hdp: 2,
  ou: 3,
  ml: 4,
  periodNumber: 5,
  status: 13,
}

export const GRADING_UNIT_TYPE = {
    REGULAR: 'Regular',
    SETS: 'Sets',
    GAMES: 'Games'
}

export const EventPeriod = {
    periodNum: 0,
    name: 1,
    homeFav: 2,
    awayFav: 3,
    ml: 4
}

export const TopMenuItem = {
    SPORT: 0,
    LIVE: 1,
    ESPORT: 2
}

export const BetslipSelectionType = {
    NORMAL: 'NORMAL',
    OUTRIGHT: 'OUTRIGHT',
    TEASERS: 'TEASERS'
}

export const CASINO_GAME_TYPE = {
    AG: 'AG',
    PT: 'PT',
    IF: 'IF',
    SG: 'SG',
    agin: 'agin',
    diamond: 'diamond',
    sapphire: 'sapphire',
    iforium: 'iforium',
    DG: 'DG',
    EG: 'EG',
    PP: 'PP',
    ZNTH: 'ZNTH',
    KY: 'KY',
    BG: 'BG',
}

export const CASINO_GAME_TYPE_TEXT = {
    AG: 'AG Live Casino',
    AGIN: 'AGIN Live Casino',
    IFORIUM: 'Featured Casino',
    SG: 'Solid Gaming Casino',
    DG: 'Dream Gaming',
    EG: 'Evolution Gaming',
    PP: 'Pragmatic Play',
    ZNTH: 'Zenyth Casino',
    KY: 'KY Gaming',
    BG: 'Big Gaming',
}

export const LIVE_CASINO_GAME_TYPE = {
    ION: 'ION',
    CR855: 'CR855',
    AG: 'AG',
}

export const CASINO_CATEGORY_TYPE = {
    NORMAL: 'NORMAL',
    NEW: 'NEW'
}

export const PRODUCT_CODE = {
    SB: 'SB',
    CASINO: 'CASINO',
    AGIN: 'AGIN',
    PLAYTECH: 'PLAYTECH',
    IFORIUM: 'IFORIUM',
    SG: 'SG',
    AG: 'AG',
    CR855: 'CR855',
    ION: 'ION',
    VS: 'VS',
    RB: 'RB',
    HR: 'HR',
    ALL: 'ALL',
    BB: 'BB',
    DG: 'DG',
    EG: 'EG',
    PP: 'PP',
    ZNTH: 'ZNTH',
    KY: 'KY',
    BG: 'BG',
}
export const OTHER_PRODUCT_CODE = [
    'DG',
    'EG',
    'PP',
    'AG',
    'ZNTH',
    'KY',
    'BG',
]

export const blockedCountries = {
    'AG': false,
    'AGIN': false,
    'ION': false,
    'CR855': false,
    'PLAYTECH': false,
    'IFORIUM': false
}

export const PLATFORM = {
    PC: 'PC',
    MOBILE: 'MOBILE'
}

export const STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
}

export const WAGER_STATUS = {
    UNAVAILABLE: 'UNAVAILABLE',
    ODDS_CHANGE: 'ODDS_CHANGE'
}

export const CLASSIC_COUNTDOWN = {
    LIVE: 20,
    NON_LIVE: 60,
    OUTRIGHT: 20,
    ZERO: 0
}

export const RoundRobinOption = {
    PARLAY: 'Parlay',
    TWO_LEGS: 'TwoLegRoundRobin',
    THREE_LEGS: 'ThreeLegRoundRobin',
    FOUR_LEGS: 'FourLegRoundRobin',
    FIVE_LEGS: 'FiveLegRoundRobin',
    SIX_LEGS: 'SixLegRoundRobin',
    SEVEN_LEGS: 'SevenLegRoundRobin',
    EIGHT_LEGS: 'EightLegRoundRobin'
}

export const ClassicOddsResp = {
    event: 'e',
    liveUpdate: 'ul',
    update: 'u',
    liveEvent: 'l',
    normalEvent: 'n',
    parlayEvent: 'pn',
    parlayLiveEvent: 'pl',
    parlayUpdateEvent: 'pu'
}

export const UpdateOdds = {
    periodNum: 0,
    betType: 1,
    selectionType: 2,
    hdp: 3,
    odds: 4,
    oddsFm: 5,
    lineId: 6,
    oldLineId: 7,
    alt: 8,
    signal: 9,
    status: 10,
    action: 11,
    eventId: 12
}

export const UpdateScore = {
    score: 0,
    time: 1,
    action: 2,
    eventId: 3
}

export const UpdateCard = {
    card: 0,
    action: 2,
    eventId: 3
}

export const UpdateRunningState = {
    runningPeriod: 0,
    runningTime: 1,
    action: 2,
    eventId: 3
}

export const SportEventsUpdate = {
    sportId: 0,
    update: 1,
    version: 2,
    running: 3
}

export const TeamType = {
    home: 0,
    away: 1,
    draw: 2,
    team1: 0,
    team2: 1
}

export const ClassicSportEvents = {
    sportId: 0,
    sportName: 1,
    leagueEvents: 2,
    group: 3,
    version: 4,
    hasDrawPrice: 5
}

export const ClassicLeagueEvents = {
    id: 0,
    name: 1,
    events: 2
}

export const ClassicEvent = {
    id: 0,
    homeName: 1,
    awayName: 2,
    time: 3,
    running: 4,
    live: 5,
    periods: 6,
    scores: 7,
    redCards: 8,
    teamType: 9,
    baseBall: 10,
    homePitcher: 11,
    awayPitcher: 12,
    runningTime: 13,
    runningPeriod: 14,
    eventStatus: 15,
    liveCenter: 16,
    liveTV: 17,
    liveCenterId: 18,
    moreBets: 19,
    totalOutrightOdds: 20,
    maxMoneyLine: 21,
    maxHdp: 22,
    maxTotal: 23,
    maxTeamtotals: 24,
    rotNum: 25
}

export const Market = {
    None: -1,
    Early: 0,
    Today: 1,
    Live: 2,
    All: 3,
    Parlay: 4,
    Outright: 5,
    CorrectScore: 6,
    Teasers: 7,
    DoubleChance: 8
}

export const EsportMarket = {
    None: -1,
    PreGame: 0,
    Soon: 1,
    Live: 2,
    All: 3,
    Parlay: 4,
    Outright: 5,
    CorrectScore: 6,
    Teasers: 7
}

export const DateMenuItem = {
    sportName: 0,
    displayDate: 1,
    date: 2,
    totalMatch: 3,
    dayOfWeek: 4
}

export const getLeftMenuHeaderGroup = (value) => {
    return getKeyorValue(LeftMenuHeaderGroup, value)
}

export const MARKET = (market) => {
    return getKeyorValue(Market, market)
}

export const getMarketName = (market) => {
    return getKeyorValue(MarketLabel, market)
}
export const getEsportMarketName = (market) => {
    return getKeyorValue(EsportMarketLabel, market)
}

export const getEsportMarket = (market) => {
    return getKeyorValue(EsportMarket, market)
}

export const getBetTypeGroup = (betTpeGroup) => {
    return getKeyorValue(BetTypeGroupLabel, betTpeGroup);
}
export const getBetTypeGroupByValue = (BetTypeGroupByValue) => {
    return getKeyorValue(BetTypeGroup, BetTypeGroupByValue);
}

export const getEsportMarketFromUrl = (betTpeGroup) => {
    return getKeyorValue(EsportMarketFromUrlLabel, betTpeGroup);
}


export const MarketLabel = {
    0: 'Early',
    1: 'Today',
    2: 'Live',
    3: 'All',
    4: 'Parlay',
    5: 'Outright',
    6: 'Correct Score',
    7: 'Teasers',
    8: 'Double Chance'
}

export const EsportMarketFromUrlLabel = {
    0: 'id',
    1: 'Live',
    2: 'Soon',
    3: 'PreGame'
}

export const EsportMarketLabel = {
    0: 'PreGame',
    1: 'Soon',
    2: 'Live',
    3: 'All',
    4: 'Parlay',
    5: 'Outright',
    6: 'Correct Score',
    7: 'Teasers'
}

export const MarketLine1x2 = {
    awayPriceFm: 0,
    homePriceFm: 1,
    drawPriceFm: 2,
    id: 3,
    alt: 4,
    maxBet: 5
}

export const MarketLineOU = {
    handicap: 0,
    points: 1,
    overOdds: 2,
    underOdds: 3,
    id: 4,
    alt: 5,
    maxBet: 6
}

export const TimeZones = {
    windowsStandardName: 0,
    olsonName: 1,
    windowsDisplayName: 2
}

export const TeaserMarketLineOU = {
    overPoint: 0,
    underPoint: 1,
    teaserId: 2,
    selectedPoint: 3,
    id: 4,
    alt: 5,
    maxBet: 6
}

export const TeaserPoint = {
    value: 0,
    label: 1
}

export const TeaserMarketLineHDP = {
    homePoint: 0,
    awayPoint: 1,
    homeFav: 2,
    awayFav: 3,
    teaserId: 4,
    selectedPoint: 5,
    id: 6,
    alt: 7,
    maxBet: 8
}

export const OddsPageFilter = {
    ALL: { val: 'all', label: 'All' },
    ML: { val: 'ml', label: 'THE_1X2' },
    OU: { val: 'ou', label: 'TOTAL' },
    HDP: { val: 'hdp', label: 'HANDICAP' },
    TEAM_TOTALS: { val: 'tt', label: 'TEAM_TOTAL' }
}

export const TeaserEventPeriodHDPOU = {
    hdp: 0,
    ou: 1,
    ml: 2,
    periodNum: 3,
    name: 4,
    homeFav: 5,
    awayFav: 6
}

export const Statement = {
    date: 0,
    day: 1,
    statementDate: 2,
    type: 3,
    turnOver: 4,
    commission: 5,
    cashBalance: 6,
    amount: 7,
    currency: 8,
    transferTime: 9,
    walletCode: 10,
    walletName: 11
}

export const MarketLineHDP = {
    awaySpread: 0,
    homeSpread: 1,
    handicap: 2,
    homeOdds: 3,
    awayOdds: 4,
    homeFav: 5,
    awayFav: 6,
    id: 7,
    alt: 8,
    maxBet: 9
}

export const MarketLineTeamTotalsOU = {
    homeTeam: 0,
    awayTeam: 1,
    total: 2
}

export const MarketLineTeamTotals = {
    home: 0,
    away: 1,
    id: 2,
    alt: 3,
    maxBet: 4
}

export const EventPeriodHDPOU = {
    handicap: 0,
    totalOU: 1,
    moneyLine: 2,
    statusPeriod: 11 
}

/**
 * Possible update actions
 */
export const UpdateAction = {
    UPDATE_ODD: 0,
    UPDATE_HANDICAP: 1,
    ADD_EVENT: 2,
    DELETE_EVENT: 3,
    ADD_MARKET_LINE: 4,
    DELETE_MARKET_LINE: 5,
    DELETE_PERIOD: 6,
    ADD_PERIOD: 7,
    EVENT_STATUS: 8,
    RUNNING_STATE: 9,
    UPDATE_SCORE: 10,
    UPDATE_CARD: 11,
    UPDATE_INFO: 12
}

export const Period = {
    FullTime: 0,
    HalfTime: 1,
    TeamTotal: 2,
    Proposition: 3
}

export const EuroEventPeriod = {
    Scores: 11,
    RedCards: 12
}

export const EventOrder = {
    Time: 0,
    League: 1
}

export const Currency = {
    USD: 'USD',
    CNY: 'CNY',
    MBT: 'MBT'
}

export const OddsFormat = {
    American: 0,
    Decimal: 1,
    HongKong: 2,
    Indonesian: 3,
    Malay: 4,
    AM: 0,
    EU: 1,
    HK: 2,
    ID: 3,
    MY: 4
}

export const OddsFormatShortLabel = {
    0: 'A',
    1: 'D',
    2: 'H',
    3: 'I',
    4: 'M'
}

export const OddsFormatText = {
    "AM": "AmericanOdds",
    "EU": "DecimalOdds",
    "HK": "HKOdds",
    "ID": "IndonesianOdds",
    "MY": "MaLayOdds"
}

export const OddsMaxBetSettingBase = ["AM"]

export const OddsFormatMB = {
    American: 0,
    Decimal: 1,
    HongKong: 2,
    Indonesian: 3,
    Malay: 4
}

export const Mode = {
    NORMAL: 0,
    PARLAY: 1,
    OUTRIGHT: 2,
    TEASER: 3,
    VS_NORMAL: 4,
    LC: 5,
    INPLAY: 6,
    PARLAY_MARKET: 7,
    OUTRIGHT_MARKET: 8,
    TEASER_MARKET: 9,
    FAVORITE: 10,
    VS_PARLAY: 11,
    SEARCH: 12,
}

export const BetTypeGroup = {
    HDP_OU: 1,
    ML_1X2: 2,
    TEAM_TOTAL: 100,
    TEASERS: 4,
    MIX_PARLAY: 101,
    OUTRIGHT: 102,
    CORRECT_SCORE: 103,
    SPECIAL: 104,
    DOUBLE_CHANCE: 105
}

export const OUTRIGHT_TYPE = {
    OUTRIGHT: 1,
    SPECIAL: 2,
    CORRECT_SCORE: 3,
    DOUBLE_CHANCE: 4
}

export const BetTypeGroupLabel = {
    1: 'Matches',
    2: 'ML1X2',
    100: 'Team Total',
    4: 'Teasers',
    101: 'Mix Parlay',
    102: 'Outright',
    103: 'Correct Score',
    104: 'Specials',
    105: 'Double Chance'
}

export const E_SPORT_PERIODS = {
    0: 'Match',
    1: 'Map 1',
    2: 'Map 2',
    3: 'Map 3',
    4: 'Map 4',
    5: 'Map 5',
    6: 'Map 6',
    7: 'Map 7',
}

export const EuroLiveGamesResp = {
    'SportEvents': 'le',
    'AvailableSports': 'ls'
}

export const BetType = {
    THE_1X2: 1,
    HANDICAP: 2,
    OU: 3,
    HOME_TOTALS: 4,
    AWAY_TOTALS: 5,
    MIX_PARLAY: 6,
    TEASER: 7,
    MANUAL_PLAY: 8,
    SPECIALS: 9,
    OE: 97,
    OUTRIGHT: 99
}

export const RBBetType = {
  SINGLE: 'SINGLE',
  PARLAY: 'PARLAY'
}

export const CommonBetType = {
    SINGLE: "SINGLE",
    PARLAY: "PARLAY",
}

export const ClassicBetType = {
    MONEYLINE: 1,
    HANDICAP: 2,
    TOTAL: 3
}

export const BetTypeDisp = {
    '1x2': '1x2',
    'HDP': 'Handicap',
    'OU': 'Over/Under',
}

export const OddsSelection = {
    'AWAY': 'AWAY',
    'HOME': 'HOME',
    'OVER': 'OVER',
    'UNDER': 'UNDER',
};

export const BetTypeSortDisp = {
    '1x2': '1x2',
    'HDP': 'HDP',
    'OU': 'OU',
};

export const OddsMode = {
    Single: 0,
    Double: 1
}

export const MarketFilter = {
    All: 100,
    _1Line: 1,
    _3Lines: 3,
    _5Lines: 5,
    Error: -1
}

export const SelectionType = {
    HOME: 0,
    AWAY: 1,
    DRAW: 2,
    OVER: 3,
    UNDER: 4,
    HOME_OVER: 5,
    HOME_UNDER: 6,
    AWAY_OVER: 7,
    AWAY_UNDER: 8,
    AAAA: 9
}

export const LeftMenuHeaderGroup = {
    SPORTS: 0,
    ESPORTS: 1,
    INPLAY: 2,
    CASINO: 3,
    LIVE_CASINO: 4,
    BET_BUILDER: 5,
    PARLAY: 6,
    KY_GAMING: 7
}

export const SportGroup = {
    SOCCER: 0,
    BASKETBALL: 1,
    TENNIS: 2,
    OTHERS: 3,
    BASEBALL: 4,
    ESPORT: 5,
    FOOTBALL: 6
}

export const VsBetType = {
    ITEM3W: 2,
    HC: 4,
    TO: 5,
    FT3W: 6,
    FT2W: 7,
    FTNW: 8,
    OUTRIGHT: 10,
    PARLAY: 99
}

export const VsSelection = {
  GOLDEN_RACE: 'Golden Race'
}

export const RaceSportId = {
    HORSE: 5,
    DOG: 6
}

export const EventPeriodFullOdds = {
    TEAM_OU: 0,
    OUTRIGHT: 1,
    HDP: 2,
    OU: 3,
    ML: 4
}

export const BreadCrumb = {
    Home: 'home',
    Sport: 'sport',
    Country: 'country',
    League: 'league',
    Event: 'event',
    Favorite: 'favorite',
    Date: 'date',
    MixParlay: 'mixparlay',
    Teaser: 'teaser',
    Level: {
        Home: 0,
        Sport: 1,
        Country: 2,
        League: 3,
        Event: 4,
        Favorite: 5,
        MixParlay: 6,
        Teaser: 7
    }
}

export const Error = {
    MSG01: 'Please login first!',
    MSG02: 'Maximun is 8 selections.',
    MSG03: 'Sorry, proccessing to add selection!',
    INTERNAL: 'INTERNAL_ERROR',
    SESSION: 'Session timeout. Please login again!',
    ERROR_IMAGE_FETCH: 'Error fetching image',
    ERROR_IMAGE_SIZE_0: 'Image size is 0',
}

export const Category = {
    MEMBER_SIGNUP: 'MEMBER_SIGNUP',
    MEMBER_ADD_BANK: 'MEMBER_ADD_BANK'
}

export const Product = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    MAINTENANCE: 'MAINTENANCE',
    CLOSED: 'CLOSED',
    WAGERING_SUSPENDED: 'WAGERING_SUSPENDED'
}

export const ParlayMenu = {
    MAIN_SPORTS: [29, 33, 4, 3, 12]
}

export const LoginStatus = {
    INVALID_USER_OR_PASS: 0,
    LOGIN_FAILED: -1,
    WRONG_COUNTRY: -2,
    ACCOUNT_UNVERIFIED: -3,
    ACCOUNT_SUSPENDED: -4,
    WRONG_ODDS_FORMAT: -5,
    ACCOUNT_MIGRATED_TO_PS3838: -6,
    TRY_IN_20_MINS: '5',
    TRY_IN_FEW_MINS: '4',
    EXCEED_FAILED_LOGIN_TIME_LIMIT: '-7',
    SUCCESS_WITH_STT_1: 1,
    SUCCESS_WITH_STT_2: 2,
    SUCCESS_WITH_STT_3: 3,
    SUCCESS_WITH_STT_6: 6,
    NO_SECURITY_QA: 7,
    SUCCESS_AFTER_MULTI_FAIL: 99,
    SELF_EXCLUSION: 'M004',
    BLOCKED_IP_RING_FENCING: 13,
    INVALID_TRUSTCODE: 14,
    INVALID_CAPTCHA: 15,
    EMPTY_CAPTCHA: 16,
    OTP_REQUIRED: 17,
    INVALID_OTP: 18,
}

export const DateIndex = {
    ALL_DATE: 8
}

export const SportMarketMap = {
    id: 0,
    live: 1,
    today_soon: 2,
    early_pregame: 3
}

export const ESportMarketMap = {
    live: 0,
    soon: 1,
    preGame: 2
}

export const TournamentMap = {
    label: 0,
    sportId: 1,
    firstMarket: 2,
    firstGameCode: 3,
    firstMarketLeagues: 4,
    marketLeagues: 5,
    gameCodeMap: 6,
    date: 7
}

export const SportItemMap = {
    id: 0,
    name: 1,
    totalEvents: 2,
    totalLines: 3,
    running: 4,
    betTypeSummary: 5,
    liveEvents: 6,
    todayEvents: 7,
    earlyEvents: 8,
    parlayEvents: 9,
    group: 10,
    outrightEvents: 11,
    correctScoreEvents: 12,
    todayLeagues: 13,
    earlyLeagues: 14,
    directPeriodsFolders: 15,
    specialEvents: 16,
    doubleChanceEvents: 17,
}

export const ESportItemMap = {
    id: 0,
    name: 1,
    code: 2,
    allLeagues: 3,
    totalEvents: 4,
    totalLines: 5,
    running: 6,
    betTypeSummary: 7,
    liveEvents: 8,
    todayEvents: 9,
    earlyEvents: 10,
    parlayEvents: 11,
    group: 12,
    outrightEvents: 13,
    correctScoreEvents: 14,
    directPeriodsFolders: 17,
    specialEvents: 18
}

export const BetTypeSummaryMap = {
    running: 0,
    group: 1,
    totalLines: 2,
    totalEvents: 3
}

export const SportEventsIndex = {
    'id': 0,
    'name': 1,
    'leagues': 2
};
export const LeagueEventsIndex = {
    'id': 0,
    'name': 1,
    'events': 2
};
export const EventIndex = {
    'id': 0,
    'homeName': 1,
    'awayName': 2,
    'lines': 3,
    'time': 4,
    'running': 5,
    'live': 6,
    'moreBets': 7,
    'periods': 8,
    'scores': 9,
    'redCards': 10,
    'teamType': 11,
    'baseBall': 12,
    'homePitcher': 13,
    'awayPitcher': 14,
    'runningTime': 15,
    'runningPeriod': 16,
    'eventStatus': 17,
    'liveCenter': 18,
    'liveTV': 19,
    'liveCenterId': 20,
    'totalMarkets': 21,
    'parlayRestriction': 22,
    'totalOutrightOdds': 23,
    'rotNum': 26
};

export const PointSportList = [1, 3, 4, 12, 17, 18, 19, 33];

export const SPORT = (value, isConvertDash) => {
    var SPORTS = {
        29: "Soccer",
        33: "Tennis",
        4: "Basketball",
        15: "Football",
        3: "Baseball",
        17: "Golf",
        19: "Hockey",
        34: "Volleyball",
        26: "Rugby League",
        22: "Mixed Martial Arts",
        18: "Handball",
        12: "E Sports",
        39: "Aussie Rules",
        6: "Boxing",
        27: "Rugby Union",
        28: "Snooker",
        45: "Cycling",
        32: "Table Tennis",
        1: "Badminton",
        2: "Bandy",
        5: "Beach Volleyball",
        7: "Chess",
        8: "Cricket",
        9: "Curling",
        10: "Darts",
        11: "Darts (Legs)",
        13: "Field Hockey",
        14: "Floorball",
        16: "Futsal",
        20: "Horse Racing",
        24: "Politics",
        30: "Softball",
        31: "Squash",
        35: "Volleyball (Points)",
        36: "Water Polo",
        37: "Padel Tennis",
        40: "Alpine Skiing",
        41: "Biathlon",
        42: "Ski Jumping",
        43: "Cross Country",
        44: "Formula 1",
        46: "Bobsleigh",
        47: "Figure Skating",
        48: "Freestyle Skiing",
        49: "Luge",
        50: "Nordic Combined",
        51: "Short Track",
        52: "Skeleton",
        53: "Snow Boarding",
        54: "Speed Skating",
        55: "Olympics",
        56: "Athletics",
        57: "Crossfit",
        58: "Entertainment",
        59: "Archery",
        60: "Drone Racing",
        62: "Poker",
        63: "Motorsport",
        64: "Simulated Games",
        65: "Sumo",
        66: "Slap Fighting"
    }
    return getKeyorValueToSports(SPORTS, value, isConvertDash);
}

export const FavouriteSport = {
    id: 0,
    count: 1,
    name: 2,
    events: 3,
    piority: 4,
    running: 5
}
export const WinRiskType = {
    RISK: "RISK",
    WIN: "WIN",
    BASE: "BASE"
}

export const OptionKeys = {
    settings: 'settings',
    time: "time",
    line: "line",
    sort: "sort",
    view: "view",
    odds: "odds",
    sound: "sound",
    selectLeagues: "select_leagues",
}

export const TeaserSports = {
    Basketball: 4,
    Football: 15
}

export const TeaserKeys = {
    teaserTypes: 'teaser-types',
    teaserPoints: 'teaser-points',
    teaserTypesPoints: 'teaser-types-points'
}

export const lcSportsSupport = [29, 33, 4];

export const LocalePath = {
    en_US: "en",
    zh_CN: "zh-cn",
    zh_TW: "zh-tw",
    id_ID: "id",
    vi_VN: "vi",
    ko_KR: "ko",
    ja_JP: "ja",
    km_KH: "km",
    th_TH: "th",
    he_IL: "he",
    es_ES: "es",
    de_DE: "de",
    fr_FR: "fr",
    pt_BR: "pt",
    ru_RU: "ru",
    tr_TR: "tr",
    hi_IN: "hi",
    hy_AM: "hy",
    ka_GE: "ka",
    uk_UA: "uk",
    sv_SE: "sv"
    ,fi_FI: "fi",
    nb_NO: "no"
}

export const VirtualSportsName = {
    VIRTUAL_SOCCER_WORLD_CUP: 'Virtual Soccer World Cup',
    VIRTUAL_SOCCER_NATIONS_CUP: 'Virtual Soccer Nations Cup',
    VIRTUAL_BASKETBALL: 'Virtual Basketball',
    VIRTUAL_SOCCER_LEAGUE: 'Virtual Soccer League',
    VIRTUAL_TENNIS: 'Virtual Tennis',
    VIRTUAL_HORSES: 'Virtual Horses',
    VIRTUAL_DOGS: 'Virtual Dogs'
}

export const VirtualSportsCode = {
    VIRTUAL_SOCCER_WORLD_CUP: 'vfwc',
    VIRTUAL_SOCCER_NATIONS_CUP: 'vf',
    VIRTUAL_BASKETBALL: 'vbl',
    VIRTUAL_SOCCER_LEAGUE: 'vflm',
    VIRTUAL_TENNIS: 'vto',
    VIRTUAL_HORSES: 'vhc',
    VIRTUAL_DOGS: 'vdr'
}

export const PARLAY_SPORTS = {
    29: "Soccer",
    4: "Basketball",
    12: "E Sports",
    3: "Baseball",
    33: "Tennis",
}

export const SPORT_MARKET_TYPES = {
    FULL_TIME: '0',
    HALF_TIME: '1',
    TEAM_TOTAL: '100',
    PARLAY: '101',
    PROPOSITION: '102',
    TEASER: '103'
}

export const SPORT_MARKET_LABEL = (type) => {
    var TYPES = {
        100: 'Team Totals - All available periods',
        102: 'Propositions / Future'
    };

    return getKeyorValue(TYPES, type);
}

export const ERROR_CODE = {
    SAME_GAME_DIFFERENT_PICK: 'SAME_GAME_DIFFERENT_PICK',
    SELECTING_PICK_DIFFERENT_SPORT: 'SELECTING_PICK_DIFFERENT_SPORT',
    SELECTING_PICK_DIFFERENT_TYPE: 'SELECTING_PICK_DIFFERENT_TYPE',
    SELECTING_PICK_DIFFERENT_POINT: 'SELECTING_PICK_DIFFERENT_POINT',
}

export const LINE_OFFERING_TYPE = {
    ALL: 'All',
    TODAY: 'Today',
    LIVE: 'Live',
}

export const PARLAY_TAB_ITEMS = {
    ACCUMULATOR: 'Accumulators',
    TEASERS: 'Teasers'

}

export const SideBarType = {
    PROMOTION: 1,
    WINNINGRIGHTNOW: 3,
    MYLASTWINS: 2,
    TOPWINNERS: 4,
    RECENTLYPLAYED: 5,
    JACKPOTS: 6,
    HOT_CASINO_GAME: 7
}
//Format URL in Banner: domain/locale/(casino|live-casino)/product/gameId
export const POSITION_CASINO_PATH = {
    PRODUCT_CODE_PATH: 1,
    GAME_ID: 2,
    CASINO_PATH: 6,
    CASINO_CATEGORY: 7
}

export const CASINO_TYPES = {
    LIVE_CASINO: 'CASINO_LIVE_IFORIUM',
    CASINO: 'CASINO_IFORIUM',
    ALL: 'ALL',
    KY_POKER:'CASINO_KY_GAMING',
}

export const WagerMyBetMap = {
    wagerId: 0,
    wagerMasterId: 1,
    status: 11,
    selection: 15,
    betType: 20,
    sportId: 23,
    sportGroup: 25,
    periodNum: 35,
    handicap: 17,
    unit: 39,
    outrightSelection: 13,
    win: 41,
    risk: 42,
    wagerSelections: 37,
    odds:18
}

export const SelectLeagueSportMap = {
    sportId: 0,
    sportName: 1,
    leagues: 2
}

export const SelectLeagueMap = {
    leagueId: 0,
    priority: 1,
    leagueName: 2,
}

export const OutrightEventMap = {
    category: 'cg',
    isLiveEvent: 'ile',
    parentEventName: 'lven',
    leagueId: 'li',
    liveEvent: 'liveEvent',
    leagueName: 'ln',
    eventDate: 'lt',
    parentEventId: 'parentId',
    specialEvents: 'se',
}

export const SpecialEventMap = {
    category: 'cg',
    date: 'd',
    eventName: 'e',
    parentEventId: 'ei',
    contestantLines: 'l',
    minBet: 'm',
    specialName: 'n',
    periodNumber: 'pe',
    specialEvents: 'si',
    specialId: 'st',
    unit: 'un',
    maxBet: 'x',
    maxBetCurrency: 'xc',
    winScores: 'winScores',
    drawScores: 'drawScores',
    loseScores: 'loseScores',
    maxScoreLine: 'maxScoreLine'
}

export const ContestantLineMap = {
    scoreTeamA: 'a',
    scoreTeamB: 'b',
    status: 's',
    contestantLineId: 'i',
    lineId: 'l',
    price: 'p',
    handicap: 'h',
    priceChange: 'c',
    rotationNumber: 'rn',
}

export default class BettingSportMenuMap {
    static isShowTodayGames(sport) {
        return sport[this.BettingSportItemMap.today];
    }

    static getLiveGames(sport) {
        return sport[this.BettingSportItemMap.liveGames];
    }

    static getPreGames(sport) {
        return sport[this.BettingSportItemMap.preGames];
    }

    static getPropositionGames(sport) {
        return sport[this.BettingSportItemMap.propositionGames];
    }

    static getGamesByCountry(sport) {
        return sport[this.BettingSportItemMap.gamesByCountry];
    }

    static getSportName(sport) {
        return sport[this.BettingSportItemMap.sportName];
    }

    static getSportId(sport) {
        return sport[this.BettingSportItemMap.sportId];
    }

    static getSubMenuTitle(subMenu) {
        return subMenu[this.BettingSubMenuItemMap.title];
    }

    static getSubMenuData(subMenu) {
        return subMenu[this.BettingSubMenuItemMap.data];
    }

    static isProposition(subMenu) {
        return subMenu[this.BettingSubMenuItemMap.isProposition];
    }


    static getLeagueName(leagueItem) {
        return leagueItem[this.LeagueItemMap.leagueName];
    }

    static getLeagueId(leagueItem) {
        return leagueItem[this.LeagueItemMap.leagueId];
    }

    static getEventIdByLeague(leagueItem) {
        return leagueItem[this.LeagueItemMap.eventId];
    }

    static getCategory(leagueItem) {
        return leagueItem[this.LeagueItemMap.category];
    }

    static allowParlay(leagueItem) {
        return leagueItem[this.LeagueItemMap.allowParlay];
    }

    static getClosingSoonEventName(event) {
        return event[this.ClosingSoonEvent.eventName];
    }

    static getClosingSoonEventId(event) {
        return event[this.ClosingSoonEvent.eventId];
    }

    static getClosingSoonEventTime(event) {
        return event[this.ClosingSoonEvent.time];
    }

    static getSportIdOfClosingSoonEvent(event) {
        return event[this.ClosingSoonEvent.sportId];
    }

    static getLeagueIdOfClosingSoonEvent(event) {
        return event[this.ClosingSoonEvent.leagueId];
    }

    static BettingSportItemMap = {
        sportId: 0,
        sportName: 1,
        today: 2,
        liveGames: 3,
        preGames: 4,
        propositionGames: 5,
        gamesByCountry: 6, // included proposition games
    }

    static BettingSubMenuItemMap = {
        title: 0,
        isProposition: 1,
        data: 2
    }

    static LeagueItemMap = {
        leagueName: 0,
        leagueId: 1,
        priority: 2,
        category: 3,
        eventId: 4,
        allowParlay: 5
    }

    static ClosingSoonEvent = {
        eventName: 0,
        eventId: 1,
        time: 2,
        rotNum: 3,
        sportId: 4,
        leagueId: 5
    }

 

}

export const SPORTS_ICON = (value) => {
    var SPORTS_ICON = {
        1: "badminton",
        2: "bandy",
        3: "baseball",
        4: "basketball",
        6: "boxing",
        5: "beach-volleyball",
        7: "chess",
        8: "cricket",
        9: "curling",
        10: "darts",
        11: "Darts (Legs)",
        12: "esport",
        13: "fieldhockey",
        14: "floorball",
        15: "football",
        16: "futsal",
        17: "golf",
        18: "handball",
        19: "hockey",
        20: "horse-racing",
        22: "martialarts",
        26: "rugby-league",
        27: "rugby-union",
        28: "snooker",
        29: "soccer",
        24: "politics",
        30: "softball",
        31: "squash",
        33: "tennis",
        32: "tabletennis",
        34: "volleyball",
        35: "volleyball",
        36: "waterpolo",
        37: "padel-tennis",
        39: "aussie-rules",
        40: "alpine-skiing",
        41: "biathlon",
        42: "skijumping",
        43: "cross-country",
        44: "formula1",
        45: "cycling",
        46: "bobsleigh",
        47: "figureskating",
        48: "freestyleskiing",
        49: "luge",
        50: "nordiccombined",
        51: "shorttrack",
        52: "skeleton",
        53: "snowboarding",
        54: "speedskating",
        55: "olympics",
        56: "athletics",
        57: "crossfit",
        58: "entertainment",
        59: "archery",
        60: "drone-racing",
        62: "poker",
        63: "motorsport",
        64: "Simulated Games",
        66: "slap-fighting"
    }
    return getKeyorValue(SPORTS_ICON, value);
}

export const MY_BETS_DATE_OPTION = {
    TODAY: {
        value: 0,
        name: 'Today',
        status: null,
    },
    TOMORROW: {
        value: 1,
        name: 'Tomorrow',
        status: 'OPEN'
    },
    ALLDATES: {
        value: -1,
        name: 'All Dates',
        status: 'OPEN'
    },
    YESTERDAY: {
        value: -2,
        name: 'Yesterday',
        status: 'SETTLED'
    },
    THEPAST7DAYS: {
        value: -7,
        name: 'The past 7 days',
        status: 'SETTLED'
    }
}

export const EVENT_SCORE = {
    PERIOD: 0,
    SCORE: 1
}

export const EventSorting = {
    TIME: "Time",
    LEAGUE: "League"
}

export const DefaultPage = {
    TODAY: "Today",
    ML_1X2: "Money Line/1x2",
    TEAM_TOTAL: "Team Totals"
}

export const DefaultMarket = [
    {
        value: "default",
        title: "Default"
    },
    {
        value: "moneyline",
        title: "Money Line/1x2"
    },
    {
        value: "spread",
        title: "Handicap"
    },
    {
        value: "total",
        title: "Totals"
    }
]

export const DATE = {
    "DAY" : [
        {"name": 1, "value": "01"},
        {"name": 2, "value": "02"},
        {"name": 3, "value": "03"},
        {"name": 4, "value": "04"},
        {"name": 5, "value": "05"},
        {"name": 6, "value": "06"},
        {"name": 7, "value": "07"},
        {"name": 8, "value": "08"},
        {"name": 9, "value": "09"},
        {"name": 10, "value": "10"},
        {"name": 11, "value": "11"},
        {"name": 12, "value": "12"},
        {"name": 13, "value": "13"},
        {"name": 14, "value": "14"},
        {"name": 15, "value": "15"},
        {"name": 16, "value": "16"},
        {"name": 17, "value": "17"},
        {"name": 18, "value": "18"},
        {"name": 19, "value": "19"},
        {"name": 20, "value": "20"},
        {"name": 21, "value": "21"},
        {"name": 22, "value": "22"},
        {"name": 23, "value": "23"},
        {"name": 24, "value": "24"},
        {"name": 25, "value": "25"},
        {"name": 26, "value": "26"},
        {"name": 27, "value": "27"},
        {"name": 28, "value": "28"},
        {"name": 29, "value": "29"},
        {"name": 30, "value": "30"},
        {"name": 31, "value": "31"}
    ],
    "MONTH": function() {
        return moment.months().map((m, k) => {return {name: m, value: (k+1)}})
    },
    "YEAR": function() {
        let years = []
        let currentYear = new Date().getFullYear()
        for(let i = currentYear - 18; i > currentYear - 100; i--) {
            years.push({name: i, value: i})
        }
        return years
    }
}

export const PrefsMap = {
    timeZoneOffset: 0,
    oddsFormat: 1,
    oddsMode: 2,
    market: 3,
    order: 4,
    sportsSorting: 5,
    enableDefaultStake: 6,
    defaultStake: 7,
    acceptBetterOdds: 8,
    updateBetslipOdds: 9,
    marketFilter: 10,
    liveScoreNotify: 11,
    timeZoneId: 12,
    acceptBetConfirmationModal: 14,
}

export const LegStatus = {
    OPEN: 'OPEN',
    WIN: 'WIN',
    LOSE: 'LOSE',
    SETTLED: 'SETTLED',
    WON: 'WON'
}

export const LEAGUE_PAGE_TYPE = {
    AVAILABLE_MARKETS: 'AVAILABLE_MARKETS',
    NORMAL_LEAGUES: 'NORMAL_LEAGUES',
    TEASERS_TYPES: 'TEASERS_TYPES'
}

export const TeaserOddsServiceResponse = {
    teaserSports: 'ts',
    teaserTypes: 'tt',
    updates: 'u',
    normalEvents: 'n',
    filterOptions: 'op'
}

export const TeaserType = {
    id: 0,
    name: 1,
    points: 2
}

export const MOBILE_VIEWS = {
    ASIA: 'asiaView',
    EURO: 'euroView',
    CLASSIC: 'classicView',
    STANDARD: 'standardView',
}

export const VIEW = {
    STANDARD: 'FUTURE',
    CLASSIC: 'CLASSIC',
    COMPACT: 'COMPACT',
    ASIAN: 'ASIA',
    NEW_ASIAN: 'COMPACT',
    EUROPE: 'EUROPE'
}

export const WALLET_METHOD = {
    SEAMLESS : 'SEAMLESS',
    TRANSFER : 'TRANSFER'
  }

export const BET_ACCEPTANCE_TYPE = {
  DANGER_ZONE: 1,
  LIVE_DELAY: 2,
  BOTH: 3
}

export const MARKET_STRATEGIES = {
  CREDIT : 'CREDIT',
  CASH : 'CASH',
  ALL : 'ALL'
}

export const USER_MODE = {
    CASH : 'cash',
    CREDIT : 'credit'
}

export const STATEMENT_TYPE = {
  OPEN_BAL: "OPEN_BAL",
  BETTING: "BETTING",
  TRANSFER: "TRANSFER",
  DEPOSIT_WITHDRAWAL: 'DEPOSIT_WITHDRAWAL',
}

export const NEW_MY_BETS_DATE_OPTION = {
    TODAY: {
        value: 0,
        name: 'Today',
        status: null,
    },
    TOMORROW: {
        value: 1,
        name: 'Tomorrow',
        status: 'OPEN'
    },
    ALLDATES: {
        value: -1,
        name: 'All Dates',
        status: 'OPEN'
    },
    YESTERDAY: {
        value: -2,
        name: 'Yesterday',
        status: 'SETTLED'
    },
    PAST7DAYS: {
        value: -7,
        name: 'Past 7 Days',
        status: 'SETTLED'
    },
    PAST4WEEKS: {
        value: -4,
        name: 'Past 4 Weeks',
        status: 'SETTLED'
    },
    CUSTOM: {
        value: 2,
        name: 'Custom',
        status: 'SETTLED'
    },
}

export const UserStatus = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  SUSPENDED_BY_COMPANY: "SUSPENDED_BY_COMPANY",
  INACTIVE: "INACTIVE",
  CLOSED: "CLOSED" 
}

export const ViewKeys = {
  classic: 'classicView',
  compact: 'compactView',
  standard: 'standardView',
  asia: 'asiaView',
  europe: 'europeView',
  newStandardView: 'newStandardView'
}

export const DISPLAY_PERIODS_FOR_SPORTS = {
    sportId: 0,
    excludedLeagueIDs: 1,
    defaultPeriod: 2,
    excludedPeriod: 3
}

export const GRADING_UNIT = {
    REGULAR: 'Regular',
    GAMES: 'Games',
    SETS: 'Sets',
}

export const PAGETYPE = {
    TODAY: 1,
    ML_1X2: 2,
    TEAM_TOTAL: 100
}

export const TYPE_MESSAGE = {
    DP: "dp"
}

export const BB_SPORTS_ICON = (value) => {
    var SPORTS_ICON = {
       1: "soccer",
       2: "basketball",
       3: "ice hockey",
       4: 'american football',
       5: "baseball"
    }
    return getKeyorValue(SPORTS_ICON, value);
}

export const LOCALE_PATH_BB = {
    en_US: "en",
    zh_CN: "zh",
    zh_TW: "zh",
    id_ID: "id",
    vi_VN: "vi",
    ja_JP: "ja",
    th_TH: "th",
    es_ES: "es-es",
    fr_FR: "fr",
    pt_BR: "pt-br",
    ru_RU: "ru",
    tr_TR: "tr"
}

export const LangCodeBB = (value) => {
    return LOCALE_PATH_BB[`${value}`] || "";
}

export const ODDS_FORMAT_BB = (value) => {
    var ODDS_FORMAT = {
    0: 'AM',
    1: 'EU',
    2 : 'HK',
    3 : 'ID',
    4 : 'MY'
    }
    return getKeyorValue(ODDS_FORMAT, value);
};

export const USER_TYPE = {
  PLAYER: 'PLAYER',
  CASH_PLAYER: 'CASH_PLAYER'
}

export const HomeMenuItem = {
    SPORTS: "sports",
    ESPORTS_HUB: "esports-hub",
    ESPORTS: "e-sports",
    DOWNLOAD: "download",
    PRESTIGE_CLUB: "prestige-club",
    PROMOTIONS: "promotions",
    LEADERBOARD: "leaderboard",
    SILVER_STAKES: "silver-stakes",
    AFFILIATE: "affiliate",
    LIVE_CASINO: "live-casino",
    CASINO: "casino",
    VS: "vs",
    "BB": "bet-builder",
    SHORTCUT_SPECIAL_LEAGUE: "shortcut-special-league",
    KY_GAMING: "chess-and-cards"
}

export const SimplifiedOriginalBetType = {
  MONEYLINE: "MONEYLINE",
  SPREAD: "SPREAD",
  TOTAL_POINTS: "TOTAL_POINTS",
  TEAM_TOTAL_POINTS: "TEAM_TOTAL_POINTS",
  SPECIALS:  "SPECIALS",
  OUTRIGHT: "OUTRIGHT"
};
  
export const SimplifiedBetType = {
  MONEYLINE: 1,
  SPREAD: 2,
  TOTAL_POINTS: 3,
  HOME_TEAM_TOTAL_POINTS: 4,
  AWAY_TEAM_TOTAL_POINTS: 5,
  SPECIALS: 99,
  OUTRIGHT: 99
}
  
export const SimplifiedSelectionType = {
  HOME: 0,
  AWAY: 1,
  DRAW: 2,
  OVER_TOTAL_POINTS: 3,
  UNDER_TOTAL_POINTS: 4,
  HOME_OVER_TEAM_TOTAL_POINTS: 5,
  HOME_UNDER_TEAM_TOTAL_POINTS: 6,
  AWAY_OVER_TEAM_TOTAL_POINTS: 7,
  AWAY_UNDER_TEAM_TOTAL_POINTS: 8,
  OUTRIGHT: 10
}
  
// status_1: show odd, status_2: hide odd
export const PERIOD_STATUS = ["status_1", "status_2"];

export const DP_ERROR = {
    NO_RECEIVE_DP_MESSAGE: "No receive dynamic parameter message"
};
export const EMPTY_VALUE = '';
export const standardizeEventParamsMap = {
    'sp': EMPTY_VALUE, // sportID
    'lg': EMPTY_VALUE, // leagueID
    'ev': EMPTY_VALUE, // eventID
    'mk': 1, // market
    'btg': 1, // bet type group
    'ot': 1, // odds type
    'd': EMPTY_VALUE, // date
    'o': 0, // event order
    'l': 2, // max line
    'v': EMPTY_VALUE, // version
    'lv': EMPTY_VALUE, // live version
    'me': 0, // more bet event 
    'more': false, // return full odds data of param me
    'lang': EMPTY_VALUE, // If locale params is empty, sports-webservice will look at this parameter
    'tm': 0, // time range
    'pa': 0, // will be return parlay if value is 1
    'c': 'Others', // Country. This param is used to filter out block sport by country config in the System config
    'g': EMPTY_VALUE, // Odds Group of user. Used for odds line fattening
    'pn': -1, // Filter for Period number. Used to filter returned period odds data. If -1, return all periods
    'ec': EMPTY_VALUE, // ESport Code. If sp==12 and ec != empty, filter returned odds with ESport Code
    'cl': -1, // Current number of line is displaying on UI
    'hle': true, // Return sp highlight events or not
    'pimo': EMPTY_VALUE, // Period in main odds. Period Numbers are separated by ,. The param presents for displaying period in odds page. This param used for getting more bet event data. API returns the rest of event periods from the displaying periods
    'inl': false, // Is New Layout. This parameter is used for Tennis sport displaying purposes. Force API always returns ML data for events
    'pv': 1, // to monitor invalid requests from BOT
    'ic': false // includeChild. This parammeter is used for get event Kills on the Regular event (Esports Matchup page)
};

export const BET_LOCATION_UNKNOWN = 'UNKNOWN';

export const ODDS_CONTAINER_CATEGORY = {
    MAIN: "MAIN",
    MORE: "MORE"
}

export const MAIN_PAGE = {
    SPORT: "SPORT",
    ESPORT: "ESPORT",
    LIVE_SPORT: "LIVE_SPORT",
    LIVE_ESPORT: "LIVE_ESPORT",
    FAVORITES: "FAVOURITES",
    SEARCH: "SEARCH",
    PROMOTED_ENTITY: "PROMOTED_ENTITY",
    EVENT: "EVENT",
    LIVE_CENTER: "LIVE_CENTER",
    LIVE_STREAMING: "LIVE_STREAMING",
    LEAGUE: "LEAGUE"
}

export const ODDS_CONTAINER_TYPE = {
    LIVE: "LIVE_CONTAINER",
    NON_LIVE: "NO_LIVE_CONTAINER"
}

export const BET_LOCATION_VIEW = {
    ASIA: "ASIAN_VIEW_MOBILE",
    EURO: "OLD_EUROPE_VIEW_MOBILE"
}

export const DATA_NOCACHE_STATUS = {
    NEW_TOKEN: "NEW_TOKEN",
    LOGOUT: "LOGOUT",
    CONVERTED: "CONVERTED",
    UNAUTHENTICATED: "UNAUTHENTICATED"
}

export const LOCAL_STORAGE_KEY = {
    TOKEN: "token",
    APP_DATA: "x-app-data",
    V_HUCODE: "v-hucode",
    SESSION_EXPIRED: "_sessionExpired",
}

export const REGEX_VALIDATION = {
    alphaCharacter: /^[0-9a-zA-Z]+$/,
    regexContainAlpha: /^.*[a-zA-Z].*$/,
    regexContainLower: /^.*[a-z].*$/,
    regexContainUpper: /^.*[A-Z].*$/,
    regexContainNumber: /^.*[0-9].*$/,
    regexJustNumber: /^[0-9]+$/,
    regexSpecialCharacter: /[!$%^&*()_+|~='"`/\\/{}\[\]:\/;<>?,.@#]/,
    regexpMultiSpace: /\s/,
  }

export const PASSWORD_RULES_KEY = [
    'REG_PASSWORD_LENGTH_INVALID',
    'REG_PASSWORD_ALPHA_INVALID',
    'REG_PASSWORD_NUMBER_INVALID'
]

export const VIP_PASSWORD_RULES_KEY = {
    MUST_NOT_EMPTY: 'MUST_NOT_EMPTY',
    LENGTH_8_TO_16_CHARACTERS: 'LENGTH_8_TO_16_CHARACTERS',
    LOWERCASE_LETTER: 'LOWERCASE_LETTER',
    UPPERCASE_LETTER: 'UPPERCASE_LETTER',
    ONE_NUMBER: 'ONE_NUMBER',
    NOT_WHITESPACE: 'NOT_WHITESPACE',
}

export const BROWSER_KEY = {
    __PREFS: "__prefs",
    _OG: "_og",
    AFRC: "afrc",
    _VID: "_vid",
    IS_SHOW_ACCEPT_TC: "isShowAcceptTC",
    SKIN: "skin",
    LOCALE: "locale",
    DISPLAY_MESS_POPUP: "displayMessPopUp",
    AFTIID: "afTtId",
    LANG: "lang",
    ASIA_PITCHERS: "asiaPitchers",
    PITCHERS: "pitchers",
    PARLAY_ACCEPT_BETTER_LINES: "parlayAcceptBetterLines",
    ACCPET_MAX_BET: "acceptMaxBet",
    ACCEPT_BETTER_LINES: "acceptBetterLines",
    PROMO_CODE: "promocode",
    BA: "ba" ,
    CLOSE_ANN_TIME: "closeAnnTime",
    SESSION: "session",
    SPECIFY_SPORT: "specifySport",
    IS_ARCADIA: "isArcadia",
    IS_ESPORTSHUB: "isEsportsHub",
    RS: "rs",
    _LOGIN_ID: "_loginId",
    EXTERNAL_URL: "external_url",
    ODDS_FORMAT: "oddsFormat",
    AUTH: "auth",
    PC_TAG: "pctag",
    DIRECTUS_TOKEN: "directusToken",
    TRUSTCODE: "trustCode"
}

export const X_APP_DATA_IGNORE_KEYS = [BROWSER_KEY.LANG, BROWSER_KEY.PC_TAG, BROWSER_KEY.DIRECTUS_TOKEN]

export const UPDATE_TENNIS_LIVE_SCORE = {
    SERVING: 0,
    H_SET: 1,
    H_GAME: 2,
    H_POINT: 3,
    A_SET: 4,
    A_GAME: 5,
    A_POINT: 6,
}

export const TENNIS_SERVING = {
    HOME: 1,
    AWAY: 2
}

export const TENNIS_LIVE_SCORE = {
    SERVING: 0,
    SET_SCORE: 1,
    GAME_SCORE: 2,
    POINT_SCORE: 3
}
export const APP_ROUTE = {
    FWP: '/m/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/asian/:view(esports-hub)?/fwp'
}
export const ZENYTH_LOCALE_MAP = {
    ZH_CN: 'zh',
    ZH_TW: 'hk'
}
export const BLOCKED_LEAGUE_NON_LOGIN = {
    SPORT_ID: 0,
    BLOCKED_ALL: 0,
    SPORTS_ID_SPECIAL: 1,
    LEAGUE_LIST: 2,
}

export const EVENT_ESPORTS_DATA_MAP = {
    ESPOSTS_DATA: 0,
    ESPORTS_INFO: 2,
    EVENT_DATA: 0,
    EVENT_INFO: 2
}

export const MAX_PARLAY_ODDS_ERROR = {
    ERROR_MAX_PARLAY_ODDS: "Your parlay has exceeded maximum payout. This wager cannot be added.",
    ERROR_MAX_ROUND_ROBIN_ODDS: "Your parlay has exceeded maximum payout. This option cannot be applied."
}

export const MAX_PARLAY_ODDS = {
    DEFAULT_VALUE_TOTAL_ROUND_ROBIN_ODDS: 0,
    DEFAULT_VALUE_TOTAL_PARLAY_ODDS: 1
}
export const DEFAULT_ATTENTION = {
    message: Constants.ATTENTION_MESSAGE.ATTENTION,
    type: Constants.ATTENTION_TYPE.ERROR,
    display: 'center'
}


export const ODDS_ID_STRUCTURE = {
    eventId: 0,
    period: 1,
    betType: 2,
    selectionType: 3,
    isAltLine: 4,
    handicap: 5
}

export const ARR_SPECIAL_ODDS_FORMAT = [OddsFormat.MY, OddsFormat.HK]

export const defaultProviders = [{
    providerId: Constants.ALL_PROVIDER_ID,
    providerName: "All Providers",
    status: STATUS.ACTIVE,
    gameType: 'ALL'
}]

export const PROVIDER_LIST_GROUP = {
    NETENT: 'netent',
    EXTEND_NETENT: 'extendednetent'
}

export const CATEGORY_PATH = {
    CASINO_CATEGORY_PATH : '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/asian/casino/:categoryName',
    LIVE_CASINO_CATEGORY_PATH: '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/asian/live-casino/:categoryName',
    KY_GAMING_CATEGORY_PATH: '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/asian/chess-and-cards/:categoryName'
}

export const VIP_TIER = {
    1: "Regular",
    2: "Silver",
    3: "Gold",
    4: "Diamond",
    5: "Platinum",
    6: "Bronze"
}

export const SUSPENSE_MESSAGE = {
    ALL_SPORTS: '0',
    MARKET_LIVE: 1,
    SERVICE_INTERVAL: 5000,
    SPORT_MAP: {
        id: 0,
        name: 1,
    },
    ASIA_SPORTSBOOK: ["leaguesPageContainer", "liveGamesContainer", "oddsPageContainer"],
    EURO_SPORTSBOOK: ["leaguesPageContainer", "liveGamesContainer", "oddsPageContainer", "homePageContainer"],
    CONFIGS: {
        ALL_WAGERING: {
            key: 'ALL_WAGERING',
            titleKey: 'SUSPEND_TITLE_ALL_WAGERING',
            contentKey: 'SUSPEND_CONTENT_ALL_WAGERING',
            allSportsContentKey: 'SUSPEND_CONTENT_ALL_SPORTS_ALL_WAGERING',
        },
        LIVE: {
            key: 'LIVE',
            titleKey: 'SUSPEND_TITLE_LIVE',
            contentKey: 'SUSPEND_CONTENT_LIVE',
            allSportsContentKey: 'SUSPEND_CONTENT_ALL_SPORTS_LIVE',
        },
        PREGAME: {
            key: 'PREGAME',
            titleKey: 'SUSPEND_TITLE_PREGAME',
            contentKey: 'SUSPEND_CONTENT_PREGAME',
            allSportsContentKey: 'SUSPEND_CONTENT_ALL_SPORTS_PREGAME',
        },
    },
}

export const MESSAGE_TIMEFRAME = {
    MONTH_RANGE: [
        { key: 'LAST_3_MONTH', value: 2 },
        { key: 'LAST_6_MONTH', value: 5 },
    ],
    MESSAGES_PAGE_CONTAINER: 'messagesPageContainer',
    LOAD_MORE_THRESHOLD: 25,
}

export const STATUS_WAGER = {
	CANCELLED: 'CANCELLED',
    MANUAL: 'MANUAL',
    REFUNDED: 'REFUNDED'
}

export const OddsFormatStatement = {
    American: "A",
    Decimal: "E",
    HongKong: "H",
    Indonesian: "I",
    Malay: "M",
  };
  
export const ALL_SPORTS = () => {
    try {
        const supportedSports = (window.env || {}).supportedSports;
        if (!supportedSports) {
            console.error("supportedSports is not defined in window.env");
            return {};
        }

        const allSportsArray = JSON.parse(window.atob(supportedSports));

        return allSportsArray.reduce((acc, sport) => {
            acc[sport.sportId] = sport.sportName;
            return acc;
        }, {});
    } catch (error) {
        return {};
    }
};
  
  export const STATEMENT_BET_TYPES = {
    WAGER: {
      value: "wager",
      label: "Bet",
    },
    DEPOSIT: {
      value: "deposit",
      label: "Deposit",
    },
    WITHDRAWAL: {
      value: "withdrawal",
      label: "Withdrawal",
    },
    TRANSFER: {
      value: "transfer",
      label: "Transfer",
    },
    PROMOTION: {
      value: "promotion",
      label: "Promotion",
    },
    ADJUSTMENT: {
      value: "adjustment",
      label: "Adjustment",
    },
  };
  
  export const StatementPeriodFilterTrans = {
    period: "Period",
    currentMonth: "Current Month",
    lastMonth: "Last Month",
  };
    
  export const timeZoneNames = {
    "Etc/GMT+12": "GMT+1200",
    "Etc/GMT+11": "GMT+1100",
    "Pacific/Honolulu": "Hawaii Standard Time",
    "America/Anchorage": "Alaska Standard Time",
    "America/Tijuana": "Pacific Standard Time",
    "America/Los_Angeles": "Pacific Standard Time",
    "America/Phoenix": "Mountain Standard Time",
    "America/Chihuahua": "Mexican Pacific Standard Time",
    "America/Denver": "Mountain Standard Time",
    "America/Guatemala": "Central Standard Time",
    "America/Chicago": "Central Standard Time",
    "America/Mexico_City": "Central Standard Time",
    "America/Regina": "Central Standard Time",
    "America/Bogota": "Colombia Standard Time",
    "America/New_York": "Eastern Standard Time",
    "America/Indianapolis": "Eastern Standard Time",
    "America/Asuncion": "Paraguay Summer Time",
    "America/Halifax": "Atlantic Standard Time",
    "America/Cuiaba": "Amazon Standard Time",
    "America/La_Paz": "Bolivia Time",
    "America/Santiago": "Chile Summer Time",
    "America/Caracas": "Venezuela Time",
    "America/St_Johns": "Newfoundland Standard Time",
    "America/Sao_Paulo": "Brasilia Standard Time",
    "America/Buenos_Aires": "Argentina Standard Time",
    "America/Cayenne": "French Guiana Time",
    "America/Godthab": "West Greenland Time",
    "America/Montevideo": "Uruguay Standard Time",
    "Etc/GMT+2": "GMT+2",
    "America/Noronha": "Fernando de Noronha Time",
    "Atlantic/Azores": "Azores Standard Time",
    "Atlantic/Cape_Verde": "Cape Verde Time",
    "Africa/Casablanca": "GMT+0100",
    "Etc/GMT": "Greenwich Mean Time",
    "Europe/London": "Greenwich Mean Time",
    "Atlantic/Reykjavik": "Greenwich Mean Time",
    "Europe/Berlin": "Central European Standard Time",
    "Europe/Budapest": "Central European Standard Time",
    "Europe/Paris": "Central European Standard Time",
    "Europe/Warsaw": "Central European Standard Time",
    "Africa/Lagos": "West Africa Standard Time",
    "Africa/Windhoek": "Central Africa Time",
    "Asia/Amman": "Eastern European Standard Time",
    "Asia/Beirut": "Eastern European Standard Time",
    "Africa/Cairo": "Eastern European Standard Time",
    "Asia/Damascus": "Eastern European Standard Time",
    "Africa/Johannesburg": "South Africa Standard Time",
    "Europe/Kiev": "Eastern European Standard Time",
    "Asia/Jerusalem": "Israel Standard Time",
    "Europe/Istanbul": "Turkey Time",
    "Europe/Minsk": "Moscow Standard Time",
    "Asia/Baghdad": "Arabian Standard Time",
    "Asia/Riyadh": "Arabian Standard Time",
    "Europe/Moscow": "Moscow Standard Time",
    "Africa/Nairobi": "East Africa Time",
    "Asia/Tehran": "Iran Standard Time",
    "Asia/Dubai": "Gulf Standard Time",
    "Asia/Baku": "Azerbaijan Standard Time",
    "Indian/Mauritius": "Mauritius Time",
    "Asia/Tbilisi": "Georgia Standard Time",
    "Asia/Yerevan": "Armenia Standard Time",
    "Asia/Kabul": "Afghanistan Time",
    "Asia/Yekaterinburg": "Yekaterinburg Time",
    "Asia/Karachi": "Pakistan Standard Time",
    "Asia/Tashkent": "Uzbekistan Standard Time",
    "Asia/Calcutta": "India Standard Time",
    "Asia/Colombo": "India Standard Time",
    "Asia/Katmandu": "Nepal Time",
    "Asia/Almaty": "East Kazakhstan Time",
    "Asia/Dhaka": "Bangladesh Standard Time",
    "Asia/Rangoon": "Myanmar Standard Time",
    "Asia/Novosibirsk": "Novosibirsk Standard Time",
    "Asia/Bangkok": "Indochina Time",
    "Asia/Krasnoyarsk": "Krasnoyarsk Standard Time",
    "Asia/Shanghai": "China Standard Time",
    "Asia/Irkutsk": "Irkutsk Standard Time",
    "Asia/Singapore": "Singapore Standard Time",
    "Australia/Perth": "Australian Western Standard Time",
    "Asia/Taipei": "Taipei Standard Time",
    "Asia/Ulaanbaatar": "Ulaanbaatar Standard Time",
    "Asia/Tokyo": "Japan Standard Time",
    "Asia/Seoul": "Korean Standard Time",
    "Asia/Yakutsk": "Yakutsk Standard Time",
    "Australia/Adelaide": "Australian Central Daylight Time",
    "Australia/Darwin": "Australian Central Daylight Time",
    "Australia/Brisbane": "Australian Eastern Standard Time",
    "Australia/Sydney": "Australian Eastern Daylight Time",
    "Pacific/Port_Moresby": "Papua New Guinea Time",
    "Australia/Hobart": "Australian Eastern Daylight Time",
    "Asia/Vladivostok": "Vladivostok Standard Time",
    "Asia/Magadan": "Magadan Standard Time",
    "Pacific/Guadalcanal": "Solomon Islands Time",
    "Pacific/Auckland": "New Zealand Daylight Time",
    "Etc/GMT-12": "GMT+1200",
    "Pacific/Fiji": "Fiji Time",
    "Asia/Kamchatka": "Petropavlovsk-Kamchatski Standard Time",
    "Pacific/Tongatapu": "Tonga Standard Time",
    "Pacific/Apia": "Apia Time Zone",
  };
    
  export const STATEMENT_DEFAULT_PAGE_INDEX = 1; 
  export const LIVE_CASINO_GAME_MAPPING = {
    CR855: "CR855_CASINO",
  };
  export const CATEGORY_CODE = ["PMS","BNS","ADM","CASINO","RB"];

  export const ACTION_TYPE = {
    DEBIT: "DEBIT",
    CREDIT: "CREDIT"
  };
  
  export const REVERSAL_TRANSACTIONS = [
    "REVERSED_DEPOSIT",
    "REVERSED_WITHDRAWAL",
    "CANCELLED_REVERSED_DEPOSIT",
    "CANCELLED_REVERSED_WITHDRAWAL"
  ];
  
  export const PROMOTION_TYPE = [
    "VOUCHER_PROMOTION",
    "BONUS_PROMOTION",
    "MANUAL_BONUS_PROMOTION",
    "PROMOTION_ADJUSTMENT"
  ];
  
  export const SPORT_PRODUCTS = [
    PRODUCT_CODE.SB,
    PRODUCT_CODE.VS,
  ];
  
  export const CASINO_PRODUCTS = [
    PRODUCT_CODE.IFORIUM,
    PRODUCT_CODE.AG,
    PRODUCT_CODE.AGIN,
    PRODUCT_CODE.CASINO,
    PRODUCT_CODE.DG,
    PRODUCT_CODE.EG,
    PRODUCT_CODE.PP,
    PRODUCT_CODE.ZNTH,
    PRODUCT_CODE.KY,
    PRODUCT_CODE.BG,
  ];

export const STATEMENTS = {
    TYPE_GROUP_TRANSACTIONS: {
        // Get from response
        DEPOSIT: 'DEPOSIT',
        WITHDRAWAL: 'WITHDRAWAL',
        // Config value
        ADJUSTMENT: 'adjustment',
        PROMOTION: 'promotion'
    },
    STATUS: {
        // Get from response
        WIN: 'win',
        LOSS: 'loss',
        REFUNDED: 'refunded',
        OPEN: 'open',
        APPROVED: 'approved',
        WIN_HALF: 'win half',
        PENDING: 'pending',
        EXPIRED: 'expired',
        RUNNING: 'running',
        // Config value
        CLASSNAME_WIN: 'win',
        CLASSNAME_LOSS: 'loss',
        CLASSNAME_PENDING: 'pending',
        CLASSNAME_OTHER: 'other'
    },
    TXN_TYPE: {
        // Get from response
        WAGER: 'Wager',
        BET_ADJUSTMENT: 'BET_ADJUSTMENT',
        WITHDRAWAL: 'WITHDRAWAL',
        TRANSFER: 'TRANSFER',
        ATA_TRANSFER: 'ATA_TRANSFER',
        FEE_ADJUSTMENT: 'FEE_ADJUSTMENT',
        // Config value
        BETTING: 'BETTING',
        BETTING_ADJUSTMENT: 'BETTING_ADJUSTMENT',
        FEE_REIMBURSEMENT: 'FEE_REIMBURSEMENT'
    },
    TRANSFER: {
        // Config value
        FROM: 'FROM',
        TO: 'TO',
        ERROR: 'ERROR'
    },
    BET_ACCEPTANCE_TYPE: {
        // Config value
        DANGER_ZONE: 'DANGER_ZONE',
        LIVE_DELAY: 'LIVE_DELAY',
        LIVE: 'LIVE',
    }
}

export const WALLET_CODE = {
    ALL: "ALL",
    MAIN: "MAIN",
    BONUS: "BONUS",
}


// WEBPACK FOOTER //
// ./src/app/common/Foundation.js